import React from 'react'
import useCards from '../../../hooks/useCards'
import useOutEcosistema from '../../../hooks/useOutEcosistema'
import useTitle from '../../../hooks/useTitle'
import HomeOutActivaTuCuenta from '../../ecosistemas/HomeOutActivaTuCuenta'
import PrincipalContactoResumen from '../../principal/components/PrincipalContactoResumen'
import "../styles/vidaplus.css";

const HomeOutVidaPlus = () => {

  useTitle({ title: 'Vital Plus | BNP Paribas Cadif' })
  const { ecosistemaPresentacionOut } = useOutEcosistema()
  const { ecosistemaCards } = useCards()

  return (
    <>
      {ecosistemaPresentacionOut(9)}

      {ecosistemaCards(9)}


      <HomeOutActivaTuCuenta />
      <div style={{background:'var(--bg_claro)'}}>

        <PrincipalContactoResumen />
      </div>
    </>
  )
}

export default HomeOutVidaPlus